import { render } from "./EditTranslationTable.vue?vue&type=template&id=5ce8c1aa&scoped=true"
import script from "./EditTranslationTable.vue?vue&type=script&lang=js"
export * from "./EditTranslationTable.vue?vue&type=script&lang=js"

import "./edit-translation-table.scss?vue&type=style&index=0&id=5ce8c1aa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce8c1aa"]])

export default __exports__